import type { BatchData } from '../types';

/**
 * Default shape for a new batch — matches the original Shared HTML so that
 * import/export and stored data are interchangeable.
 *
 * Field names are load-bearing. Don't rename without coordinating with the
 * backend zod schema in functions/api/batches/*.ts.
 */
export const PHASES = [
  'Water',
  'Oil',
  'Cool-down',
  'Active',
  'Fragrance',
  'Preservative',
  'Adjust',
] as const;

export const STATUS_COLORS: Record<string, string> = {
  draft: '#aaa',
  'in-progress': '#9A6D28',
  testing: '#3B6EA0',
  approved: '#5C7A52',
  rejected: '#B5614A',
  archived: '#bbb',
};

export function defaultBatch(n: number): BatchData {
  return {
    metaBatchId: 'HH-00' + n,
    metaProduct: '',
    metaDate: '',
    metaVersion: 'v1.0',
    metaFormulator: '',
    metaBatchYield: '',
    metaBottleSize: '',
    metaUnits: '',
    metaTemp: '',
    metaCoolTemp: '',
    metaMixTime: '',
    metaMixMethod: '',
    metaEmulsify: '',
    metaPHTarget: '5.0–6.5',
    metaPHMeasured: '',
    metaPHAdjuster: '',
    metaViscosity: '',
    metaEquipment: '',
    metaAppearance: '',
    metaScent: '',
    metaSkinFeel: '',
    batchNotes: '',
    batchQC: '',
    metaPreservation: '',
    metaStabilityDate: '',
    metaSafety: '',
    batchStatus: 'draft',
    rows: [
      {
        ingredient: 'Distilled Water',
        inci: 'Aqua',
        supplier: '',
        phase: 'Water',
        amount: '72.50',
        notes: 'Base / carrier',
      },
      {
        ingredient: 'Aloe Vera Gel',
        inci: 'Aloe Barbadensis Leaf Juice',
        supplier: 'Hensley Produce',
        phase: 'Water',
        amount: '10.00',
        notes: 'Soothing, hydrating — farm-grown',
      },
      {
        ingredient: 'Glycerin',
        inci: 'Glycerin',
        supplier: '',
        phase: 'Water',
        amount: '3.00',
        notes: 'Humectant',
      },
      { ingredient: '', inci: '', supplier: '', phase: 'Oil', amount: '', notes: '' },
    ],
  };
}
